import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import MaintElements from "./MaintElements";

export default class MaintDetailDefault extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      notFound: false,
      pending: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let item = await this.context.api.q("/maintenance/get", {
      id: this.props.itemId,
    });
    this.setState({
      pending: false,
      item: item,
      notFound: !item,
    });
  };

  onMethodFinish = () => {
    if (this.props.onAfterSave) {
      this.props.onAfterSave(this.state.item);
    }
    this.load();
  };

  onDeleteClick = (item = {}) => {
    this.context
      .ask(
        `Вы действительно хотите удалить ТО ${item.label}`,
        "Удаление ТО",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item = {}) => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/maintenance/delete", {
      id: item.id,
    });
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast(`ТО удалено`, "success");
    } else {
      this.context.toast(`Не удалось удалить ТО`, "error");
    }
    if (this.props.onAfterSave) {
      this.props.onAfterSave(item);
    }
    this.context.redirect(`/maint/${this.props.structureId}/`);
  };

  render() {
    const { pending, notFound, item } = this.state;
    const { manageMaint, shipId, structureId, itemId } = this.props;
    return (
      <>
        <Blocker on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className="mt-5 d-flex justify-content-between">
                <div>
                  <div className="text-dark-50 small font-italic">
                    {item.shipname}
                  </div>
                  <h5>{item.label}</h5>
                  <div className="text-muted">{item.description}</div>
                </div>
                {manageMaint && (
                  <div className="ml-3">
                    <div className=" d-flex justify-content-end align-items-center">
                      <Link
                        className="mr-4"
                        title={`Редактировать ТО ${item.label}`}
                        to={`/maint/${structureId}/${itemId}/edit`}
                      >
                        <i className="fa fa-pencil text-hover-primary"></i>
                      </Link>

                      <EssenceStateLabel
                        stateCode={item.statetypecode}
                        stateLabel={item.statelabel}
                        essence="maintenance"
                        id={item.id}
                      />
                      <EssenceActionsDropdown
                        essence={"maintenance"}
                        key={item.id}
                        id={item.id}
                        label={item.label}
                        onFinish={this.onMethodFinish}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-5"></div>
              <MaintElements {...this.props} />
            </>
          )}
        </Blocker>
      </>
    );
  }
}
